import { moduleFactory } from "@/store/helpers";
import modules from "./modules";
import { actions } from "./actions";
import { state } from "./state";
import { mutations } from "./mutations";

export { state, mutations, actions, modules };

export default moduleFactory({
  namespaced: true,
  state,
  mutations,
  actions,
  modules
});
